module.exports = __webpack_public_path__ + "static/beammm-b84555397841745babb692ef5ff0011a.mp4";